__turbopack_context__.v({
  "cont": "CallbackForm-module-scss-module__DLjG5G__cont",
  "dataChunk": "CallbackForm-module-scss-module__DLjG5G__dataChunk",
  "error": "CallbackForm-module-scss-module__DLjG5G__error",
  "form": "CallbackForm-module-scss-module__DLjG5G__form",
  "img": "CallbackForm-module-scss-module__DLjG5G__img",
  "privacy": "CallbackForm-module-scss-module__DLjG5G__privacy",
});
